function iqxWebBuildAgencyMenu(menu){
  'use strict';

  menu.addItem({
    id:'iqxWeb_menu_home',
    title:'Home',
    icon:'fas fa-home',
    url:'/home'
  })

  menu.addItem({
    id:'iqxWeb_menu_contactDetails',
    title:'Contact Details',
    icon:'fas fa-pencil-alt',
    url:'/agencycontact'
  })

  menu.addItem({
    id:'iqxWeb_menu_candidates',
    title:'Candidates',
    icon:'fas fa-users',
    url:'/agencycandidates'
  })

  menu.addItem({
    id:'iqxWeb_menu_currentOpportunities',
    title:'Current Opportunities',
    icon:'fas fa-binoculars',
    url:'/currentopportunities',
    rights:'CURRENTOPPORTUNITIES'
  })

  menu.addDropdown({
    id:'iqxWeb_menu_timesheets',
    title:'Timesheets',
    icon:'fas fa-building',
  }).subMenu
    .addItem({
      id:'iqxWeb_menu_current',
      title:'Current',
      url:'/provtimesheets/fill',
      rights:'FILLTIMESHEETS'
    })
    .addItem({
      id:'iqxWeb_menu_completed',
      title:'Completed',
      url:'/timesheets'
    })
  
  menu.addItem({
    id:'iqxWeb_menu_contacts',
    title:'Contacts',
    icon:'fas fa-users',
    url:'/contacts',
    rights:'MAINTAINCONTACTS'
  })

  menu.addItem({
    id:'iqxWeb_menu_reports',
    title:'Reports',
    icon:'fas fa-chart-pie',
    url:'/reports',
    rights:'MANAGEMENTINFO'
  })

  menu.addSplitter({
    id:'iqxWeb_menu_splitter'
  })
  
  menu.addItem({
    id:'iqxWeb_menu_settings',
    title:'Settings',
    icon:'fas fa-cog',
    url:'/settings'
  })

  menu.addItem({
    id:'iqxWeb_menu_help',
    title:'Help',
    icon:'fas fa-question-circle',
    url:'/help',
    switches:'SHOWFAQPAGE'
  })

  menu.addLogoutButton({
    id:'iqxWeb_menu_logout',
    title:'Logout',
    icon:'fas fa-sign-out-alt',
    click:'logout()',
    switches:'AGENCY_LOGOUT_NAV'
  })

}
